import {
    LOGIN_DONE,
    LOGIN_ERROR,
    LOGIN_REQUEST,
    LOGOUT_REQUEST,
    LOGOUT_CONFIRMED,
    LOGOUT_CANCEL
} from "../../constants/action-types";

import initialState from "../initialState";

const login = (state = initialState.login, action) => {
    switch (action.type) {
        case LOGIN_REQUEST:
            if (state.loginState === 1) { return state; }

            return {
                ...state,
                loginState: 1,
                user: action.payload.user,
                pswd: action.payload.pswd
            }

        case LOGIN_DONE:
            return {
                ...state,
                loginState: 2,
                user: '',
                pswd: ''
            }

        case LOGIN_ERROR:
            return { ...state, loginState: 3 }

        case LOGOUT_REQUEST:
            if (state.loginState === 4) { return state; }
            return { ...state, loginState: 4 }

        case LOGOUT_CONFIRMED:
            if (state.loginState === 5) { return state; }
            return { ...state, loginState: 5 }

        case LOGOUT_CANCEL:
            return { ...state, loginState: 2 }

        default:
            return state;
    }
}

export default login;


// WEBPACK FOOTER //
// ./src/store/reducers/login.js